import * as React from 'react';
import './SendToAnalyzeMenu.less';
import { Menu } from 'antd';
import { useAppStore } from '../../stores';
import { CustomSourceOption } from '../../../custom_shared/types';

const APPS_SOURCE_ID = 'iota_apps';

const SendToAnalyzeMenu: React.FC = () => {
    const { sessionStore, sourceStore } = useAppStore();

    const [sourceOptions, setSourceOptions] = React.useState<CustomSourceOption[]>([]);

    React.useEffect(() => {
        if (sessionStore.response?.sources) {
            sourceStore.getSourceOptions(APPS_SOURCE_ID)?.then(setSourceOptions);
        }
    }, [sessionStore.response, sourceStore]);

    const handleAnalyze = (applicationId: string) => {
        sessionStore.analyzeDocument(applicationId);
    };

    if (sourceOptions.length === 0) {
        return null;
    }

    return (
        <Menu.SubMenu
            key="send-to-analyze"
            title="Send to analysis"
            disabled={!sessionStore.processedPackageId || sessionStore.analysisIsLocked}
        >
            {sourceOptions.map(option => (
                <Menu.Item key={option.value} onClick={() => handleAnalyze(option.value)}>
                    {option.label}
                </Menu.Item>
            ))}
        </Menu.SubMenu>
    );
};

export default SendToAnalyzeMenu;
